

/*
	Source: htdocs/wim/js/core/src/PlayerProfile.js
*/
(function($, wimbledonCore) {
/**
     *  Poller Class
     *      Used for setting up repeating AJAX loads. Supports
     *      a variety of options ranging from simple to complex.
     */
    function PlayerProfile() {
        var id = 'PlayerProfile';
        var logger = new eventsCore.util.Logger(id);
        var api = new Object();

        var months = {};
        months['january'] = 0;
        months['february'] = 1;
        months['march'] = 2;
        months['april'] = 3;
        months['may'] = 4;
        months['june'] = 5;
        months['july'] = 6;
        months['august'] = 7;
        months['september'] = 8;
        months['october'] = 9;
        months['november'] = 10;
        months['december'] = 11;

        /**
         * calculate player age based date string 
         * @dateStr  date in format "26 December 1985"
         * return   integer of age value
         */
        api.calculateAge = function(dateString) {
            //logger.info('calculateAge - date:%o', dateString);
            if (typeof dateString === 'undefined')
                return '';

            var date = dateString.split(' ');

            if (date.length < 3)
                return '';

            var birthDate = new Date(date[2], months[date[1].toLowerCase()], date[0]);
            var serverDate = wimbledonCore.getServerDate();

            var nowyear = serverDate.getFullYear();
            var nowmonth = serverDate.getMonth();
            var nowday = serverDate.getDate();

            var birthyear = birthDate.getFullYear();
            var birthmonth = birthDate.getMonth();
            var birthday = birthDate.getDate();

            var age = nowyear - birthyear;
            var age_month = nowmonth - birthmonth;
            var age_day = nowday - birthday;
           
            if(age_month < 0 || (age_month == 0 && age_day <0)) {
                age = parseInt(age) -1;
            }
            
            //logger.info('calculateAge - b:%o', age);
            return age;
        };

        return api;
    };

    wimbledonCore.playerProfile = new PlayerProfile();

}(jQuery, window.wimbledonCore));